<template>
    <div class="breadCrumbs__piece">
      <BreadCrumbs
        v-if="getParent !== undefined"
        :node="getParent"
        :currentSlug="currentSlug"
      />
      <!--
      <div v-else class="breadCrumbs__line"></div>
      <span v-else-if="node.sys.contentType.sys.id === 'tags'">
        {{ node.fields.title }}
      </span>
      <span v-else-if="node.sys.contentType.sys.id === 'tagsParent'">
        {{ node.fields.title }}
      </span>
      <router-link
        v-else-if="node.sys.id !== '7JBWTWGTBw454cKpn988Jk'"
        :to="{ name: 'single-category', params: { slug: node.fields.category.fields.slug } }">
        {{ node.fields.category.fields.title }}
      </router-link>
      -->
      <router-link
        v-if="node.sys.id !== '7JBWTWGTBw454cKpn988Jk' && (typeof node.fields.category !== 'undefined')"
        :to="{ name: 'single-category', params: { slug: node.fields.category.fields.slug } }">
        {{ node.fields.category.fields.title }}
      </router-link>
      <span v-if="node.sys.contentType.sys.id === 'products'">
        {{ node.fields.title }}
      </span>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BreadCrumbs from '@/components/BreadCrumbs/BreadCrumbs.vue'
export default {
  name: 'BreadCrumbs',
  components: {
    BreadCrumbs
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    currentSlug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'nodes'
    ]),
    getParent: {
      get () {
        if (this.node.sys.id === '7JBWTWGTBw454cKpn988Jk') return undefined
        // se tagParent, ritorno undefined
        if (this.node.sys.contentType.sys.id === 'tagsParent') {
          return undefined
        }
        // se tag, ritorno il padre
        if (this.node.sys.contentType.sys.id === 'tags') {
          return this.node.fields.parentGroup
        }
        // se prodotto, ritono il nodo che lo contiene
        if (this.node.sys.contentType.sys.id === 'products') {
          return this.nodes.find(node => {
            if (typeof node.fields.products === 'undefined') return false
            return node.fields.products.find(product => {
              return product.sys.id === this.node.sys.id
            }) !== undefined
          })
        }
        // se nodo, ritorno il nodo padre
        return this.nodes.find(node => {
          if (typeof node.fields.nodesList === 'undefined') return false
          return node.fields.nodesList.find(node => {
            return node.sys.id === this.node.sys.id
          }) !== undefined
        })
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadNodes'
    ]),
		async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadNodes()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }

}
</script>

<style lang="scss">
  @import './../../assets/scss/breakpoint.scss';
  @import './../../assets/scss/typo.scss';
  .breadcrumbs__container{
    @include site-paddings;
    margin: 2rem 0 0;
    @include media(">=large"){
      margin: 2rem 0;
    }
    .breadCrumbs__line{
      display: inline-block;
      width: 40px; height: 1px;
      background-color: #484848;
      top: -3px;
    }
    .breadCrumbs__piece{
      line-height: 1;
      display: inline-block;
      a, span{
        margin-right: 10px;
        padding-left: 15px;
        text-decoration: none;
        display: inline-block;
        @include site-labels($color: #989898);

        &:before{
          content:"/";
          position: absolute;
          left:0; top:0;
          @include site-labels($color: #989898);
        }
      }
      span{
        @include site-labels($color: #484848);
      }
    }
  }
</style>
